var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('Header',{on:{"change":_vm.menuChange,"changeType":_vm.moduleChange}}),_c('div',{staticClass:"controller-content"},[_c(_vm.showComponent,{tag:"component",attrs:{"modeuleType":_vm.modeuleType}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }